/**
 * Reinitializes Gravity Forms after a Barba.js page transition.
 *
 * @param {string} html - The full HTML string of the next page fetched by Barba.
 * @param {boolean} debug
 */
export function refreshGravityForms(html, debug = false) {
    if (!html) return;

    if (html.indexOf('gform_wrapper') === -1 && html.indexOf('gform_fields') === -1) {
        return;
    }

    if (typeof gform === 'undefined') {
        if (debug) console.warn('[Gravity Forms] gform global not found. Ensure gform_gravityforms_theme is enqueued on all pages.');
        return;
    }

    document.querySelectorAll('[data-barba="container"]').forEach(container => {
        if (container.style.display === 'none') {
            container.querySelectorAll('.gform_wrapper, iframe[name^="gform_ajax_frame"]').forEach(el => {
                el.remove();
            });
            if (debug) console.log('[Gravity Forms] Cleaned up stale elements from hidden Barba container.');
        }
    });

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const scripts = doc.querySelectorAll('script');

    let executedCount = 0;

    scripts.forEach(script => {
        const content = script.textContent;
        if (!script.src && (
            content.includes('gform.initializeOnLoaded') ||
            content.includes('gf_global') ||
            content.includes('gform_post_render') ||
            content.includes('gform_ajax_frame')
        )) {
            try {
                window.eval(content);
                executedCount++;
            } catch (err) {
                if (debug) console.warn('[Gravity Forms] Error executing inline script:', err);
            }
        }
    });

    if (debug && executedCount > 0) {
        console.log(`[Gravity Forms] Evaluated ${executedCount} inline form setup script(s).`);
    }
}
